import React, { useState } from 'react';
import useTransactionHistory, { downloadTransactionCSV } from '../data/transactionHistory';
import { Button, Pagination, PageHeader } from '../ui';
import AuthService from '../services/authentication'
import { useHistory } from 'react-router-dom';
import LoadingComponent from '../helpers/LoadingComponent';
import TransactionTable from './TransactionTable';

function Transactions() {
  const [page, setPage] = useState(0);
  const [key, setKey] = useState('all');
  const [search, setSearch] = useState("");
  const [submittedSearch, setSubmittedSearch] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [submittedStartDate, setSubmittedStartDate] = useState("");
  const [submittedEndDate, setSubmittedEndDate] = useState("");
  let auth = AuthService.useAuth()
  const { transactions, total_count, isLoading, isError, mutateTransactionHistory } = useTransactionHistory(page, key, submittedSearch, submittedStartDate, submittedEndDate, auth.authHeader());
  const history = useHistory()
  const totalPages = Math.ceil(total_count / 20);

  const handleSearchChange = event => {
    setSearch(event.target.value);
  }

  const handleDownload = async () => {
    const result = await downloadTransactionCSV(auth.authHeader(), startDate, endDate);
    if (result.success) {
      alert('Your report has been sent to your email.');
    } else {
      alert('Something went wrong. Please try again.');
    }
  }

  const handleSearchSubmit = () => {
    setSubmittedSearch(search);
    setSubmittedStartDate(startDate);
    setSubmittedEndDate(endDate);
    mutateTransactionHistory(); 
  }

  return (
    <div className="mx-auto w-full max-w-screen-xl px-4">
      <PageHeader title="Transactions" />
      <div className="flex mb-3">
        <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
        <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
        <Button onClick={handleSearchSubmit}>Search</Button>
      </div>
      {isLoading ? (
        <LoadingComponent />
      ) : isError ? (
        <div>Error: {isError.message}</div>
      ) : (
        <>
          <Button variant="primary" onClick={handleDownload}>Download</Button>
          <TransactionTable transactions={transactions} history={history} />
          <Pagination
            page={page}
            totalPages={totalPages}
            totalCount={total_count}
            onPageChange={setPage}
          />
        </>
      )}
    </div>
  );
}

export default Transactions;